import moment from "moment";
import * as echarts from "echarts";
const getOption = (data1: Array<number>, type: string): any => {
  const x: string[] = [];
  const y: number[] = [];
  const days: string[] = [];
  let stationName: string = "";
  data1.forEach((e: any) => {
    x.push(
      moment(e.datetime, "YYYYMMDDHHmmss")
        .add(8, "hour")
        .format("DD日HH") + "时"
    );
    y.push(Math.round(e.prs * 10) / 10);
    stationName = e.stationName
  });

  const min = Math.min.apply(
    Math,
    data1.map(function(o: any) {
      return o.prs;
    })
  );
  const max = Math.max.apply(
    Math,
    data1.map(function(o: any) {
      return o.prs;
    })
  );
  const fontSize = 14;

  let leftPostion = 15;
  let topPostion = 30;
  let yAxisShow = false;
  let splitLine = false;
  let showAllSymbol = false;
  let titleShow = false;
  let xInterval = 5;
  let dataZoomDisAble = false;
  let dataZoom = 100;
  let xLabelFormat = undefined;
  let bottomPostion = 35;
  let tooltipShow = false;
  if (type === "full") {
    leftPostion = 35;
    topPostion = 40;
    titleShow = true;
    yAxisShow = true;
    splitLine = true;
    showAllSymbol = true;
    xInterval = 0;
    dataZoomDisAble = true;
    dataZoom = 80;
    xLabelFormat = function(value: string) {
      let pattern = new RegExp("[\u4E00-\u9FA5]+");
      const values = value.split("");
      let result = "";
      values.forEach((charValue) => {
        result += charValue;
        if (pattern.test(charValue)) {
          result += "\n";
        }
      });
      return result;
    };
    bottomPostion = 80;
    tooltipShow = true;
  }

  return {
    animation: false,
    grid: {
      left: leftPostion,
      right: 10,
      top: topPostion,
      bottom: bottomPostion,
    },
    tooltip: {
      trigger: "axis",
      show: tooltipShow,
      valueFormatter: function(value: any) {
        return value + "";
      },
    },
    title: {
      show: titleShow,
      textStyle: {
        color: "#2D96F7",
      },
      text: stationName+"-过去24小时气压(hpa)",
    },
    xAxis: {
      type: "category",
      data: x,
      boundaryGap: true,
      alignTicks: true,
      axisLabel: {
        fontFamily: "PingFangSC-Regular",
        interval: xInterval,
        formatter: xLabelFormat,
      },
      axisLine: {
        lineStyle: {
          show: false,
          color: "#2D96F7",
        },
      },
      axisTick: {
        show: false,
      },
    },
    dataZoom: [
      {
        type: "inside",
        disabled: !dataZoomDisAble,
        start: 0,
        end: dataZoom,
      },
    ],
    yAxis: {
      show: yAxisShow,
      type: "value",
      min: Math.round(min - 1),
      max: Math.round(max + 1),
      splitNumber: 1,
      splitLine: { show: splitLine },
      axisLine: {
        show: true,
        lineStyle: {
          color: "#2D96F7",
        },
      },
      interval: 1,
      axisLabel: {
        formatter: function(value: number) {
          return value + "";
        },
      },
    },
    series: {
      data: y.map((item, index) => {
        return {
          value: item,
          label: {
            // 设置显示label
            show: true,
            // 设置label的位置
            position: index % 2 === 0 ? "top" : "bottom",
            color: "#2D96F7",
            fontSize,
            distance: 12,
          },
        };
      }),
      showAllSymbol: showAllSymbol,
      symbol: "circle",
      smooth: true,
      markPoint: {
        symbol: "pin",
        data: [
          {
            type: "max",
            name: "Max",
            itemStyle: {
              color: "rgba(255, 178, 12, 0.9)",
            },
          },
        ],
      },
      // label: {
      //   show: true,
      //   color: "#ED8E25",
      //   fontSize,
      // },
      lineStyle: {
        width: 2,
        color: "RGBA(83, 169, 250, 1)",
      },
      itemStyle: {
        color: "#2D96F7",
      },
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(17, 134, 242, 0.5)",
          },
          {
            offset: 1,
            color: "rgba(17, 134, 242,0)",
          },
        ]),
      },
      type: "line",
      yAxisIndex: 0,
    },
  };
};
export default getOption;
